// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';
import { PaginationConst } from '../constants/AppConstant';

/**
 * @description Get release based on the request criteria
 * @param {String} productId
 * @returns {Promise}
 */
export async function createBorrowers(releaseObj: Object = {}) {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers`,
    data: releaseObj,
  }); return response.data;
}

export async function getBorrowers( pageNumber: number = 0,pageSize:number = PaginationConst.PAGE_SIZE,  filterObj: Object = {}) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/borrowers?includeOutstanding=true&page=${pageNumber}&size=${pageSize}`,
  }); 
  return response.data;
}

// export async function getLeadsById(leadId: string) {
//   const response = await HttpClient.GET({
//     BASE_URL: LEAD_SERVICE_HOST,
//     END_POINT: `${LEAD_API_PREFIX}/leads/${leadId}`
//   }); 
//   return response;
// }
